import { Request } from '~src/httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '~src/spacesPlatform/utils/actionParams';

import { IViewActions } from '../types/IViewActions';

export class GetViewActionsRequest extends Request<ISingleIdParams, IViewActions> {
  constructor(id: string) {
    super('getViewActions', { id: id });
  }
}
